"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawToolbar = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const draw_button_1 = require("../../components/button/draw.button");
const icons_1 = require("../../components/icon/icons");
const modal_service_1 = require("../../components/modal/modal.service");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const draw_toolbar_style_1 = require("./draw.toolbar.style");
(0, theme_1.addStyles)(draw_toolbar_style_1.Style);
function trackOnClick(draw, action, value, cb) {
    return () => {
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, action, draw.collection.revision, value !== null && value !== void 0 ? value : undefined);
        cb();
    };
}
exports.DrawToolbar = {
    viewInsightGroup(draw, ctx) {
        var _a;
        const isIkeAnalyst = services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
        // If the image is not markable, then don't show tools
        if (!draw.isMarkable) {
            return null;
        }
        const isInsightVisible = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_INSIGHT_AHOA) || isIkeAnalyst;
        const isInsightSparkleDisabled = !draw.drawState.hasInsightDetections();
        const isInsightMasksDisabled = !draw.drawState.hasVisibleInsightMasks((_a = ctx.insightMaskTypesVisible) !== null && _a !== void 0 ? _a : [], draw.log);
        const arrangeEnabled = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_ANNOTATIONS_ARRANGE) || isIkeAnalyst;
        return (0, mithril_1.m)('div', { className: draw_toolbar_style_1.CSS.group }, [
            ...((isInsightVisible && [
                draw_button_1.DrawButton.view(icons_1.MaterialIcon.SPARKLE, {
                    disabled: isInsightSparkleDisabled,
                    isSelectedInsight: draw.state.visibleInsightMarkers,
                    title: isInsightSparkleDisabled
                        ? i18n_1.T.TOOL_INSIGHT_DETECTIONS_MARKERS_NONE
                        : i18n_1.T.TOOL_INSIGHT_DETECTIONS_TOGGLE_MARKERS,
                    onclick: trackOnClick(draw, `insightDetections:markers:toggle:`, null, () => draw.state.setInsightMarkersVisible(!draw.state.visibleInsightMarkers)),
                }),
                draw_button_1.DrawButton.view(icons_1.MaterialIcon.MASK_BLUR, {
                    disabled: isInsightMasksDisabled,
                    isSelectedInsight: draw.state.visibleInsightMasks,
                    title: isInsightMasksDisabled ? i18n_1.T.TOOL_INSIGHT_DETECTIONS_MASKS_NONE : i18n_1.T.TOOL_INSIGHT_DETECTIONS_TOGGLE_MASKS,
                    onclick: trackOnClick(draw, 'insightDetections:masks:toggle:', null, () => draw.state.setInsightMasksVisible(!draw.state.visibleInsightMasks)),
                }),
            ]) ||
                []),
            ...((arrangeEnabled && [
                draw_button_1.DrawButton.view(icons_1.MaterialIcon.VERTICAL_DISTRIBUTE, {
                    title: i18n_1.T.TOOL_ARRANGE_ANNOTATIONS,
                    isSelectedInsight: draw.state.autoArrangeAnnotations,
                    onclick: trackOnClick(draw, 'autoArrangeAnnotations:toggle', null, () => draw.state.setAutoArrangeAnnotations(!draw.state.autoArrangeAnnotations, ctx)),
                }),
            ]) ||
                []),
        ]);
    },
    viewToolGroup(draw) {
        if (!draw.isMarkable) {
            return null;
        }
        if (draw.state.tool === core_shared_1.IkeDrawTool.BASE) {
            return (0, mithril_1.m)('div', { className: draw_toolbar_style_1.CSS.group }, [
                draw_button_1.DrawButton.view(icons_1.MaterialIcon.POLE_BASE, {
                    title: i18n_1.T.TOOL_BASE,
                    selected: true,
                    onclick: () => {
                        services_1.Services.Analytics.trackTiming(core_api_1.TimingEventType.HOA, core_api_1.TimingEventAction.ENTER, draw.collection.id, new Date());
                        trackOnClick(draw, 'tool:base', null, () => false)();
                    },
                }),
            ]);
        }
        return (0, mithril_1.m)('div', { className: draw_toolbar_style_1.CSS.group }, [
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.PHOTO_MEASURE, {
                flip: true,
                title: i18n_1.T.TOOL_HEIGHT,
                selected: draw.state.tool === core_shared_1.IkeDrawTool.MARKER,
                onclick: () => {
                    services_1.Services.Analytics.trackTiming(core_api_1.TimingEventType.HOA, core_api_1.TimingEventAction.ENTER, draw.collection.id, new Date());
                    trackOnClick(draw, 'tool:marker', null, () => draw.state.toggleTool(core_shared_1.IkeDrawTool.MARKER))();
                },
            }),
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.PHOTO_MEASURE, {
                title: i18n_1.T.TOOL_WIDTH,
                selected: draw.state.tool === core_shared_1.IkeDrawTool.LINE,
                onclick: trackOnClick(draw, 'tool:line', null, () => draw.state.toggleTool(core_shared_1.IkeDrawTool.LINE)),
            }),
        ]);
    },
    viewWireGroup(draw, isZoomRendererShown) {
        const isWireMeasurable = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_WIRE_MEASURE);
        if (isZoomRendererShown && isWireMeasurable) {
            return (0, mithril_1.m)('div', { className: draw_toolbar_style_1.CSS.group }, [
                draw_button_1.DrawButton.view(icons_1.MaterialIcon.ADD, {
                    title: i18n_1.T.TOOL_CABLE_MEASURE_INCREASE,
                    hidden: !isZoomRendererShown || !draw.state.showCablemeasure,
                    disabled: !draw.state.canIncreaseCablemeasure,
                    onclick: trackOnClick(draw, 'cablemeasure:up', draw.state.cablemeasure, () => draw.state.cablemeasureIncrease()),
                }),
                draw_button_1.DrawButton.view(icons_1.MaterialIcon.SQUARE_FOOT, {
                    title: i18n_1.T.TOOL_CABLE_MEASURE,
                    hidden: !isZoomRendererShown,
                    selected: draw.state.showCablemeasure,
                    onclick: trackOnClick(draw, 'cablemeasure:toggle', draw.state.cablemeasure, () => draw.state.toggleCablemeasure()),
                }),
                draw_button_1.DrawButton.view(icons_1.MaterialIcon.REMOVE, {
                    title: i18n_1.T.TOOL_CABLE_MEASURE_DECREASE,
                    hidden: !isZoomRendererShown || !draw.state.showCablemeasure,
                    disabled: !draw.state.canDecreaseCablemeasure,
                    onclick: trackOnClick(draw, 'cablemeasure:down', draw.state.cablemeasure, () => draw.state.cablemeasureDecrease()),
                }),
            ]);
        }
        return null;
    },
    viewZoomGroup(draw) {
        return (0, mithril_1.m)('div', { className: draw_toolbar_style_1.CSS.group }, [
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.ZOOM_IN, {
                title: i18n_1.T.TOOL_ZOOM_IN,
                disabled: draw.state.zoom >= core_shared_1.IkeDrawState.ZOOM_MAX,
                onclick: trackOnClick(draw, 'zoom:increase', draw.state.zoom, () => draw.state.zoomIncrease()),
            }),
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.ZOOM_OUT, {
                title: i18n_1.T.TOOL_ZOOM_OUT,
                disabled: draw.state.zoom <= core_shared_1.IkeDrawState.ZOOM_DEFAULT,
                onclick: trackOnClick(draw, 'zoom:decrease', draw.state.zoom, () => draw.state.zoomDecrease()),
            }),
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.ZOOM_OUT_MAP, {
                title: i18n_1.T.TOOL_ZOOM_RESET,
                disabled: draw.state.zoom === core_shared_1.IkeDrawState.ZOOM_DEFAULT,
                onclick: trackOnClick(draw, 'zoom:reset', draw.state.zoom, () => draw.state.zoomReset()),
            }),
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.SET_CROP, {
                hidden: draw.isMarkable,
                flip: true,
                title: i18n_1.T.TOOL_CROP_SET,
                onclick: trackOnClick(draw, 'crop:set', draw.state.cropX, () => {
                    const resolution = draw.capture.resolution;
                    const center = draw.state.center;
                    const zoomFactor = draw.state.zoom;
                    const zoomWidth = resolution.width / zoomFactor / 2;
                    const zoomHeight = resolution.height / zoomFactor / 2;
                    if (zoomFactor === 1) {
                        draw.state.setCrop(0, 0, 0, 0);
                    }
                    else {
                        if (center.x - zoomWidth < 0) {
                            center.x = zoomWidth;
                        }
                        else if (center.x + zoomWidth > resolution.width) {
                            center.x = resolution.width - zoomWidth;
                        }
                        if (center.y - zoomHeight < 0) {
                            center.y = zoomHeight;
                        }
                        else if (center.y + zoomHeight > resolution.height) {
                            center.y = resolution.height - zoomHeight;
                        }
                        const x = center.x - zoomWidth;
                        const y = center.y - zoomHeight;
                        const width = zoomWidth * 2;
                        const height = zoomHeight * 2;
                        draw.state.setCrop(x, y, width, height);
                    }
                }),
            }),
        ]);
    },
    viewBrightnessGroup(draw) {
        return (0, mithril_1.m)('div', { className: draw_toolbar_style_1.CSS.group }, [
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.BRIGHTNESS_HIGH, {
                title: i18n_1.T.TOOL_BRIGHTNESS_INCREASE,
                disabled: !draw.state.canIncreaseBrightness,
                onclick: trackOnClick(draw, 'brightness:increase', draw.state.brightness, () => draw.state.brightnessIncrease()),
            }),
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.BRIGHTNESS_MEDIUM, {
                title: i18n_1.T.TOOL_BRIGHTNESS_RESET,
                disabled: draw.state.brightness === core_shared_1.IkeDrawState.BRIGHTNESS_DEFAULT,
                onclick: trackOnClick(draw, 'brightness:reset', draw.state.brightness, () => draw.state.brightnessReset()),
            }),
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.BRIGHTNESS_LOW, {
                title: i18n_1.T.TOOL_BRIGHTNESS_DECREASE,
                disabled: !draw.state.canDecreaseBrightness,
                onclick: trackOnClick(draw, 'brightness:decrease', draw.state.brightness, () => draw.state.brightnessDecrease()),
            }),
        ]);
    },
    viewInfoGroup(draw) {
        return (0, mithril_1.m)('div', { className: draw_toolbar_style_1.CSS.group }, [
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.LASER, {
                title: i18n_1.T.TOOL_LASER_TOGGLE,
                hidden: !draw.isIkePhoto,
                selected: draw.state.isCrosshairVisible,
                onclick: trackOnClick(draw, `crosshair:${draw.state.isCrosshairVisible ? 'on' : 'off'}`, null, () => draw.state.setCrosshair(!draw.state.isCrosshairVisible)),
            }),
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.INFO, {
                title: i18n_1.T.TOOL_INFO_TOGGLE,
                disabled: !draw.isIkePhoto,
                selected: draw.state.isInfoVisible,
                onclick: trackOnClick(draw, `info:${draw.state.isInfoVisible ? 'on' : 'off'}`, null, () => draw.state.setInfoVisible(!draw.state.isInfoVisible)),
            }),
        ]);
    },
    viewResetGroup(draw) {
        const isPhotoHiddenAvailable = services_1.Services.Token.has(core_api_1.IkeToken.COLLECTION_EXPORT_HIDE_FLAGGED_PHOTOS);
        const children = [];
        if (isPhotoHiddenAvailable) {
            children.push(draw_button_1.DrawButton.view(icons_1.MaterialIcon.HIDE_PHOTO, {
                flip: true,
                title: draw.state.imageVisibilityHidden ? i18n_1.T.PHOTOMEASURE_UNHIDE_IMAGE_TITLE : i18n_1.T.PHOTOMEASURE_HIDE_IMAGE_TITLE,
                selected: draw.state.imageVisibilityHidden,
                onclick: trackOnClick(draw, 'hide:photo', null, () => draw.state.toggleImageVisibility()),
            }));
        }
        children.push(draw_button_1.DrawButton.view(icons_1.MaterialIcon.DELETE, {
            title: i18n_1.T.TOOL_MEASUREMENTS_CLEAR,
            disabled: !draw.drawState.hasMeasurements() ||
                (!draw.drawState.hasUserMeasurements() && !draw.state.visibleInsightMarkers),
            onclick: () => exports.DrawToolbar.confirmClear(draw),
        }));
        return (0, mithril_1.m)('div', { className: draw_toolbar_style_1.CSS.group }, children);
    },
    view(draw, isZoomRendererShown, ctx) {
        const columns = [];
        const potentialInsightGroup = exports.DrawToolbar.viewInsightGroup(draw, ctx);
        const potentialToolGroup = exports.DrawToolbar.viewToolGroup(draw);
        const potentialWireGroup = exports.DrawToolbar.viewWireGroup(draw, isZoomRendererShown);
        const potentialZoomGroup = exports.DrawToolbar.viewZoomGroup(draw);
        const potentialBrightnessGroup = exports.DrawToolbar.viewBrightnessGroup(draw);
        const potentialInfoGroup = exports.DrawToolbar.viewInfoGroup(draw);
        const potentialResetGroup = exports.DrawToolbar.viewResetGroup(draw);
        // The insight group gets its own column
        if (potentialInsightGroup) {
            columns.push((0, mithril_1.m)('div', { className: draw_toolbar_style_1.CSS.column }, [potentialInsightGroup]));
        }
        const column2 = [
            potentialToolGroup,
            potentialWireGroup,
            potentialZoomGroup,
            potentialBrightnessGroup,
            potentialInfoGroup,
            potentialResetGroup,
        ].filter((x) => x != null);
        columns.push((0, mithril_1.m)('div', { className: draw_toolbar_style_1.CSS.column }, column2));
        return (0, mithril_1.m)('div', { className: draw_toolbar_style_1.CSS.container }, columns);
    },
    confirmClear(draw) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield modal_service_1.ModalService.open({
                title: i18n_1.T.PHOTOMEASURE_DELETE_ALL_TITLE,
                content: (0, i18n_1.Translate)(i18n_1.T.PHOTOMEASURE_DELETE_ALL_TEXT),
                hasCancel: true,
            });
            if (res.ok) {
                (0, mobx_1.runInAction)(() => {
                    draw.drawState.clear();
                    draw.init();
                    page_state_1.CurrentState.cancelInteractions();
                    services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, 'measurement:clear', draw.collection.revision);
                });
            }
        });
    },
};
//# sourceMappingURL=draw.toolbar.js.map